import api from '../../api/indicatorsRoutes.js';
 
const namespaced = true;

export const state = {
    indicadores:[],
}

const mutations = {
    MUTATION_SET_INDICADORES(state, value){
        state.indicadores = value;
    },
    MUTATION_ADD_INDICADORES(state, value){
        state.indicadores.push(value);
    },
    MUTATION_UPDATE_INDICADORES(state, value){
        const index = state.indicadores.findIndex(
            ind => ind.idIndicador === value.idIndicador
        );
        if (index !== -1) {
            state.indicadores.splice(index, 1, value);
        }
    },
    MUTATION_DELETE_INDICADORES(state, value){
        state.indicadores = state.indicadores.filter(
            ind => ind.idIndicador !== value
        );
    },
}

const actions = {
    getIndicators(context){
        return new Promise((resolve, reject) => {
            api.getIndicators().then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_SET_INDICADORES', resp.data)
                    resolve(resp.data);
                } else {
                    console.log(resp.data.message);
                    reject(new Error(resp.data?.message || 'Error al obtener indicadores'));
                }
            }).catch(error => {
                reject(error);
            });
        });
    },
    store(context, data){
        return new Promise((resolve, reject) => {
            api.store(data).then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_ADD_INDICADORES', resp.data);
                    resolve(resp.data);
                } else {
                    console.log(resp.data.message);
                    reject(new Error(resp.data?.message || 'Error al crear'));
                }
            }).catch(error => {
                reject(error);
            });
        });
    },
    update(context, {id, data}){
        return new Promise((resolve, reject) => {
            api.update(id, data).then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_UPDATE_INDICADORES', resp.data);
                    resolve(resp.data);
                } else {
                    console.log(resp.data.message);
                    reject(new Error(resp.data?.message || 'Error al actualizar'));
                }
            }).catch(error => {
                reject(error);
            });
        });
    },
    delete(context, id){
        return new Promise((resolve, reject) => {
            api.deleted(id).then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_DELETE_INDICADORES', id);
                    console.log(resp.data.message);
                    resolve(resp.data);
                } else {
                    console.log(resp.data.message);
                    reject(new Error(resp.data?.message || 'Error al eliminar'));
                }
            }).catch(error => {
                reject(error);
            });
        });
    },
}

const getters = {
    getIndicadores(state) {
        return state.indicadores;
    },
}

export default {
    namespaced,
    state,
    getters,
    mutations,
    actions
}